// src/utils/consent.js
//
// Single shared consent gate for the checkout. The React tree wires this exact
// instance into <ConsentProvider gate={gate}> (see App.js) and non-React modules
// (utils/pixels.js) import the same instance to gate third-party pixels at fire
// time. Categories in use: analytics (GA4, GTM) and marketing (Meta Pixel + CAPI).
//
// Replaces the legacy jsDelivr Osano cookieconsent (Components/CookieConsent +
// the two jsDelivr tags in public/index.html), aligning checkout with the rest of
// the ecosystem (public-v5, marketplace) on @salespark/consent-gate.
//
// History:
// 21-09-2026: Created (migrate to @salespark/consent-gate, gate GA4/Meta/GTM)

import { createConsentGate } from "@salespark/consent-gate";

/****************************************************
 * ##: Checkout consent gate
 * One gate for the whole app. `necessary` is processed under contractual basis on
 * a checkout surface (audit metadata only; it never changes gating behaviour).
 * History:
 * 21-09-2026: Created
 ****************************************************/
export const gate = createConsentGate({
  version: 1,
  sourceApp: "checkout",
  legalBasis: { necessary: "contract" },
});

/****************************************************
 * ##: Imperative per-vendor consent guards
 * For non-React code (utils/pixels.js). A vendor fires only when its category is
 * granted AND it was not individually switched off in the preferences panel.
 * History:
 * 21-09-2026: Created
 ****************************************************/
export const consent = {
  meta: () => gate.isVendorAllowed("meta-pixel", "marketing"),
  metaCapi: () => gate.isVendorAllowed("meta-conversions-api", "marketing"),
  ga4: () => gate.isVendorAllowed("ga4", "analytics"),
  gtm: () => gate.isVendorAllowed("gtm", "analytics"),
};
